import Page from '@modules/page'
import {navigate} from "@reach/router"
import {Layout, ContextualSaveBar} from "@shopify/polaris"
import {ContextProvider, useStore} from "./container"
import TitleCard from "./components/title"
import Display from "./components/display"
import Preview from "./components/preview"
import LayoutSection from "@modules/layoutSection"
import {useCallback, useState, useEffect} from "react"
import API from "@helpers/api"
import {showToast} from "@plugins/toast"
import {checkRequiredFields} from "@helpers/utils"
import ChartContent from "./components/content"
import { isEqual, omit } from 'lodash'
import DiscardModal from '../../components/discardModal'

const CreateSizeChart = () => {
	return (
		<ContextProvider>
			<CreateSizeChartView />
		</ContextProvider>
	)
}

const CreateSizeChartView = () => {
	const [loading, setLoading] = useState(false)
	let [error, setError] = useState([])
	const {state} = useStore()
	const [activeModal, setActiveModal] = useState(false);
	const [prevState, setPrevState] = useState(state)

	const isEqualState = isEqual(omit(state, ['updatedAt']), omit(prevState, ['updatedAt']))

	const handleModalChange = useCallback(() => setActiveModal(!activeModal), [activeModal]);

	useEffect(() => {
		const handleReloadPage = (e) => {
		  e.preventDefault()
		  e.returnValue = ""
		}
		if(isEqualState === false) window.addEventListener("beforeunload", handleReloadPage)
		return () => window.removeEventListener("beforeunload", handleReloadPage)
	  }, [isEqualState])
	const handleSave = async () => {
		error = await checkRequiredFields(['chart_content', 'title'], state)
		if (error.length > 0) {
			setError(error)
			window.scrollTo({top: 0, behavior: 'smooth'})
			return showToast({
				message: 'Please fill in all the mandatory fields',
				error: true
			})
		}

		const {target_products, target_collection} = state
		setLoading(true)
		API.create('size-chart', {
			...state,
			target_products: target_products?.filter(Boolean).map(p => p.value),
			target_collection: target_collection.value,
		}).then(res => {
			console.log(res, 'res')
			if (res.ok) {
				setPrevState({
					...prevState, 
					...res.payload, 
					target_products: target_products, 
					target_collection: target_collection,
				})
				navigate(`/size-chart/${res.payload._id}`)
				return showToast({
					message: 'Size chart created'
				})
			}
		})
			.finally(() => setLoading(false))
	}

	return (
		<Page
			title="Create size chart"
			breadcrumbs={[{content: 'Size chart', onAction: () => isEqualState ? navigate('/size-chart') : handleModalChange()}]}
			fullWidth
		>
			{!isEqualState && <ContextualSaveBar
				fullWidth
				message="Unsaved changes"
				saveAction={{
					onAction: handleSave,
					loading: loading,
					disabled: false,
				}}
				discardAction={{
					onAction: () => handleModalChange()
				}}
			/>}
			<Layout>
				<Layout.Section secondary>
					<TitleCard error={error} />
					<ChartContent error={error} />
					<Display />
				</Layout.Section>
				<LayoutSection isStuck>
					<Preview />
				</LayoutSection>
			</Layout>
			<DiscardModal 
				activeModal={activeModal}
				handleModalChange={handleModalChange}
				backLink='/size-chart'
			/>
		</Page>
	)
}

export default CreateSizeChart
